import api from "../Services/Api";
import {observable} from "mobx";
import IHasIdAndName from "../Entities/IHasIdAndName";

export interface StockFiltrationMethod extends IHasIdAndName {
    description: string;
}

class StockFiltrationMethodsLookupStore {
    @observable methods: StockFiltrationMethod[] = []
    async load() {
        this.methods = await api.get('stockFiltrationMethod/list');
    }
    
    first(): StockFiltrationMethod {
        return this.methods[0];
    }
}

const stockFiltrationMethodsLookupStore = new StockFiltrationMethodsLookupStore();
export default stockFiltrationMethodsLookupStore;